"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELD_HEADER_HEIGHT = void 0;
// @ts-nocheck
//titlebar at the top of component
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const theme_1 = require("../../styles/theme");
const common_1 = require("../../utils/common");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const lodash_1 = __importDefault(require("lodash"));
const FieldHeader = ({ title, submitting, canSave, onDonePress, onCancelPress, style, doneButtonText = 'Submit', children, content, canSaveActive, disableCloseButton = true, type, }) => {
    const isLocationHeader = type && lodash_1.default.isEqual(type, 'location');
    const headerStyles = useHeaderStyles({ canSave, doneButtonText, canSaveActive, isLocationHeader });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: headerStyles.header },
            react_1.default.createElement(core_1.Typography, { className: headerStyles.labelStyle },
                title,
                children),
            disableCloseButton && (react_1.default.createElement(core_1.IconButton, { onClick: () => onCancelPress && onCancelPress(), className: headerStyles.closeRoot },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faClose, className: headerStyles.closeIcon })))),
        content,
        react_1.default.createElement(core_1.Box, { className: style || headerStyles.footer },
            react_1.default.createElement(core_1.Button, { onClick: () => onCancelPress && onCancelPress(), className: headerStyles.footerCancelBtn }, "Cancel"),
            canSave ? (react_1.default.createElement(core_1.Button, { className: headerStyles.footerDoneBtn, onClick: onDonePress }, doneButtonText)) : (react_1.default.createElement("span", null)))));
};
exports.FIELD_HEADER_HEIGHT = 127;
const ModifiedBreakPoint = common_1.MOBILE_BREAKPOINT + 1;
const useHeaderStyles = styles_1.makeStyles((theme) => {
    const mobileBreakpoint = theme.breakpoints.down(ModifiedBreakPoint);
    return styles_1.createStyles({
        header: {
            padding: '18px 30px',
            backgroundColor: theme_1.colors.white,
            boxShadow: 'none',
            borderBottom: `1px solid ${theme_1.colors.black10}`,
            display: 'flex',
            justifyContent: 'space-between',
            [mobileBreakpoint]: {
                padding: '18px 22px',
            },
        },
        toolbar: {
            justifyContent: 'space-between',
            minHeight: exports.FIELD_HEADER_HEIGHT,
            padding: '0px 20px',
        },
        labelStyle: {
            color: theme_1.colors.black0,
            fontWeight: 500,
            fontSize: 19,
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            lineHeight: 'normal',
            display: 'flex',
            alignItems: 'center',
        },
        footer: {
            padding: '14px 30px',
            display: 'flex',
            flexDirection: 'row',
            gap: 14,
            alignItems: 'center',
            justifyContent: 'end',
            height: 39,
            position: 'absolute',
            bottom: 6,
            left: 0,
            right: 0,
            boxShadow: `0px -2px 4px 0px ${theme_1.colors.black05}`,
            background: theme_1.colors.white,
            zIndex: 999,
            [mobileBreakpoint]: {
                padding: '14px 22px',
                gap: 14,
                justifyContent: 'space-between',
                zIndex: 100,
            },
        },
        footerCancelBtn: (props) => (Object.assign(Object.assign(Object.assign({ border: `1px solid ${theme.palette.primary.main}`, color: theme.palette.primary.main, padding: '10px 35px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', lineHeight: 'normal', borderRadius: 5, textTransform: 'capitalize', fontFamily: 'Roboto', fontSize: 16, fontStyle: 'normal', fontWeight: 400 }, (!props.canSave && {
            position: 'absolute',
        })), (props.isLocationHeader && {
            width: '100%',
        })), { [mobileBreakpoint]: {
                width: props.canSave ? '100%' : 167.5,
                zIndex: 999,
            } })),
        footerDoneBtn: (props) => (Object.assign(Object.assign({ display: 'flex', padding: '10px 36px', justifyContent: 'center', alignItems: 'center', gap: '10px', lineHeight: 'normal', borderRadius: 5, background: theme.palette.primary.main, color: theme_1.colors.white, textTransform: 'capitalize', fontFamily: 'Roboto', fontSize: 16, fontStyle: 'normal', fontWeight: 400, width: 129, '&.MuiButton-root.Mui-disabled': {
                color: theme_1.colors.white,
                background: theme_1.colors.black15,
            } }, (props.isLocationHeader && {
            width: '100%',
        })), { '&:hover': {
                background: theme.palette.primary.main,
            }, [mobileBreakpoint]: {
                width: '100%',
            } })),
        closeRoot: {
            width: 24,
            height: 24,
        },
        closeIcon: {
            fontSize: 20,
            color: theme_1.colors.black54,
        },
    });
});
exports.default = FieldHeader;
//# sourceMappingURL=FieldHeader.js.map